var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYourOshc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.295,
    height: 81,
    viewBox: "0 0 153.295 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YourOSHC_Logo_Digital_Purple_RGB",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7557",
    "data-name": "Path 7557",
    d: "M119.427,108.267l8.8-14.567h8.38l-13.512,22.155v14.508h-7.331V115.855L102.25,93.7h8.223Z",
    transform: "translate(-100.342 -93.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7558",
    "data-name": "Path 7558",
    d: "M260.777,146.05c7.96,0,13.354,6.023,13.354,13.669s-5.394,13.512-13.354,13.512c-8.013,0-13.407-5.866-13.407-13.512S252.764,146.05,260.777,146.05Zm-.053,20.165c3.51,0,6.078-2.776,6.078-6.5,0-3.77-2.566-6.6-6.078-6.6s-6.023,2.829-6.023,6.6C254.7,163.439,257.216,166.215,260.724,166.215Z",
    transform: "translate(-217.009 -135.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7559",
    "data-name": "Path 7559",
    d: "M415.286,175.949v-2.157a9.523,9.523,0,0,1-7.123,2.941c-5.6,0-8.9-3.921-8.9-10.162V150.338h7.333v14.926c0,3.247,1.31,4.923,4.033,4.923,2.827,0,4.66-2.157,4.66-5.866V150.33h7.333v25.619Z",
    transform: "translate(-339.119 -139.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7560",
    "data-name": "Path 7560",
    d: "M551.37,146.8v2.145A7.886,7.886,0,0,1,557.811,146c4.556,0,7.49,2.88,7.437,10.587l-7.227,1.206a7.311,7.311,0,0,0,.053-1.049c0-2.723-1-4.031-2.986-4.031-2.094,0-3.725,1.78-3.725,6.021V172.4H544.03V146.8Z",
    transform: "translate(-455.504 -135.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7561",
    "data-name": "Path 7561",
    d: "M111.476,311.83c11.1,0,18.749,8.484,18.749,19.214,0,10.683-7.646,19.018-18.749,19.018-11.207,0-18.906-8.327-18.906-19.018C92.568,320.313,100.267,311.83,111.476,311.83Zm-.053,31.207c6.7,0,11.47-5.027,11.47-11.993,0-7.019-4.766-12.2-11.47-12.2s-11.515,5.19-11.515,12.209C99.909,337.963,104.614,343.037,111.423,343.037Z",
    transform: "translate(-92.56 -269.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7562",
    "data-name": "Path 7562",
    d: "M308.612,343.013c4.556,0,7.123-1.99,7.123-4.976,0-2.3-2.253-3.874-7.96-4.451-8.536-.839-12.94-4.609-12.94-11.419,0-6.127,5.6-10.368,13.3-10.368,6.966,0,12.307,4.084,13.826,10.264l-6.9,2.886c-.943-3.725-3.613-6.078-6.913-6.078-3.562,0-5.97,1.414-5.97,3.457,0,2.2,1.414,3.457,6.441,3.98,9.323.943,14.456,4.451,14.456,11.521,0,7.229-5.656,12.2-14.456,12.2-8.38,0-14.14-4.817-15.71-12.568l6.807-2.515C300.87,340.191,304.064,343.013,308.612,343.013Z",
    transform: "translate(-253.62 -269.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7563",
    "data-name": "Path 7563",
    d: "M473.871,315.822v14.4h16.706v-14.4h7.333v36.663h-7.333V337.242H473.871v15.242H466.54V315.82Z",
    transform: "translate(-393.207 -272.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7564",
    "data-name": "Path 7564",
    d: "M659.207,311.83c8.327,0,14.35,4.87,15.763,12.156l-6.546,2.41c-.784-4.509-4.243-7.542-9.27-7.542-6.65,0-11.156,5.237-11.156,11.568,0,7.49,4.609,12.622,11.568,12.622,5.343,0,9.74-3.457,10.317-8.8l7.07,1.623c-.943,8.329-8.17,14.193-17.177,14.193-11.522,0-19.116-8.064-19.116-19.018C640.668,320.208,648,311.83,659.207,311.83Z",
    transform: "translate(-533.188 -269.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7565",
    "data-name": "Path 7565",
    d: "M833.556,459.28a4.479,4.479,0,0,1,0,8.954,4.478,4.478,0,1,1,0-8.954Z",
    transform: "translate(-684.598 -387.603)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYourOshc);
export default __webpack_public_path__ + "static/media/logo-your-oshc.28cb68286d85599bafa8bd1c0532cd08.svg";
export { ForwardRef as ReactComponent };